const firstNonEmpty = (...values) => {
  const value = values.find((item) => item !== undefined && item !== null && String(item).trim());
  return value === undefined ? '' : String(value).trim();
};

const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

export const normalizeOptionalOrderPostalCode = (value) => {
  const input = String(value ?? '').trim();
  const postalCode = digitsOnly(input);
  return { valid: !input || postalCode.length === 8, postalCode };
};

export const normalizeMapSuggestionAddress = (suggestion = {}) => {
  const address = suggestion.address || {};
  const position = suggestion.position || {};
  return {
    postalCode: digitsOnly(firstNonEmpty(address.postalCode, address.cep)).slice(0, 8),
    streetName: firstNonEmpty(address.streetName, address.street),
    streetNumber: firstNonEmpty(address.streetNumber, address.houseNumber, address.number),
    neighborhood: firstNonEmpty(address.neighborhood, address.district),
    city: firstNonEmpty(address.city),
    state: firstNonEmpty(address.state, address.stateCode).toUpperCase().slice(0, 2),
    country: firstNonEmpty(address.country, address.countryCode, 'BR').toUpperCase().slice(0, 2),
    latitude: firstNonEmpty(position.lat),
    longitude: firstNonEmpty(position.lng),
    label: firstNonEmpty(suggestion.label, address.label, suggestion.title),
  };
};

export const mergeOrderAddressSuggestion = (form = {}, suggestion = {}) => {
  const address = normalizeMapSuggestionAddress(suggestion);
  return {
    ...form,
    postalCode: address.postalCode,
    streetName: address.streetName || form.streetName || '',
    streetNumber: address.streetNumber || form.streetNumber || '',
    neighborhood: address.neighborhood,
    city: address.city,
    state: address.state,
    country: address.country || 'BR',
  };
};

export const buildOrderAddressSuggestionRequest = (form = {}) => {
  const streetName = String(form.streetName || '').trim();
  const city = String(form.city || '').trim();
  const state = String(form.state || '').trim();
  const country = String(form.country || 'BR').trim().toUpperCase();
  const q = [streetName, city, state, country].filter(Boolean).join(', ');
  return {
    q,
    ...(city ? { city } : null),
    ...(state ? { state } : null),
  };
};
